import React from 'react';
import TopRecommendBanner from '../TopRecommendBanner/TopRecommendBanner';
import { useStyles } from './styles';

const DefaultMenuGroupRecommend = ({
  section,
  topBannerRef,
  topBannerText,
}) => {
  const classes = useStyles();

  return (
    <div key={section.name} id={section.name} className={classes.container}>
      <div>
        <div ref={topBannerRef}>
          <TopRecommendBanner topBannerText={topBannerText} />
        </div>
      </div>
    </div>
  );
};

export default DefaultMenuGroupRecommend;
